import { useRef } from "react";
import { BarChart } from "./barChart";

import TEXT from "../../../utils/text/prensa.json";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

export default function StepBars({ currentStepIndex, stepNumber, progress }) {
  const percChnge = 0.6;
  const percChnge2 = 0.65;

  const barGraph = useRef();
  const height =
    barGraph.current && barGraph.current.offsetHeight !== 0
      ? barGraph.current.offsetHeight - 20
      : 0;

  const { language } = useCurrentLanguage();
  const data = [
  {
    x: language === "es" ? "T1'17" : "Q1'17",
    titular_pos: 8.0912,
    titular_neg: 62.954,
    titular_neu: 28.9528,
    cuerpo_pos: 26.0876,
    cuerpo_neg: 12.3228,
    cuerpo_neu: 61.5904,
  },
  {
    x: language === "es" ? "T2'17" : "Q2'17",
    titular_pos: 10.7736,
    titular_neg: 62.5472,
    titular_neu: 26.678,
    cuerpo_pos: 30.306,
    cuerpo_neg: 10.5544,
    cuerpo_neu: 59.14,
  },
  {
    x: language === "es" ? "T3'17" : "Q3'17",
    titular_pos: 9.5396,
    titular_neg: 61.4552,
    titular_neu: 29.006,
    cuerpo_pos: 30.242,
    cuerpo_neg: 11.4664,
    cuerpo_neu: 58.2928,
  },
  {
    x: language === "es" ? "T4'17" : "Q4'17",
    titular_pos: 8.942,
    titular_neg: 61.8948,
    titular_neu: 29.1628,
    cuerpo_pos: 31.1216,
    cuerpo_neg: 9.8972,
    cuerpo_neu: 58.9812,
  },
  {
    x: language === "es" ? "T1'18" : "Q1'18",
    titular_pos: 8.2892,
    titular_neg: 60.9876,
    titular_neu: 30.7228,
    cuerpo_pos: 29.126,
    cuerpo_neg: 12.2132,
    cuerpo_neu: 58.6616,
  },
  {
    x: language === "es" ? "T2'18" : "Q2'18",
    titular_pos: 9.0676,
    titular_neg: 63.5924,
    titular_neu: 27.3388,
    cuerpo_pos: 29.3292,
    cuerpo_neg: 11.9408,
    cuerpo_neu: 58.7268,
  },
  {
    x: language === "es" ? "T3'18" : "Q3'18",
    titular_pos: 9.4384,
    titular_neg: 61.7292,
    titular_neu: 28.834,
    cuerpo_pos: 31.1716,
    cuerpo_neg: 11.7044,
    cuerpo_neu: 57.124,
  },
  {
    x: language === "es" ? "T4'18" : "Q4'18",
    titular_pos: 8.9316,
    titular_neg: 63.7844,
    titular_neu: 27.2848,
    cuerpo_pos: 29.3612,
    cuerpo_neg: 11.6332,
    cuerpo_neu: 59.0048,
  },
  {
    x: language === "es" ? "T1'19" : "Q1'19",
    titular_pos: 10.7984,
    titular_neg: 61.222,
    titular_neu: 27.9808,
    cuerpo_pos: 34.638,
    cuerpo_neg: 10.0904,
    cuerpo_neu: 55.2724,
  },
  {
    x: language === "es" ? "T2'19" : "Q2'19",
    titular_pos: 8.814,
    titular_neg: 63.1228,
    titular_neu: 28.0624,
    cuerpo_pos: 28.4988,
    cuerpo_neg: 10.1784,
    cuerpo_neu: 61.3228,
  },
  {
    x: language === "es" ? "T3'19" : "Q3'19",
    titular_pos: 10.244,
    titular_neg: 58.7844,
    titular_neu: 30.9724,
    cuerpo_pos: 33.1232,
    cuerpo_neg: 10.8148,
    cuerpo_neu: 56.062,
  },
  {
    x: language === "es" ? "T4'19" : "Q4'19",
    titular_pos: 10.7616,
    titular_neg: 58.5772,
    titular_neu: 30.6608,
    cuerpo_pos: 30.4532,
    cuerpo_neg: 10.332,
    cuerpo_neu: 59.2164,
  },
  {
    x: language === "es" ? "T1'20" : "Q1'20",
    titular_pos: 10.2717,
    titular_neg: 61.98,
    titular_neu: 27.7492,
    cuerpo_pos: 33.9829,
    cuerpo_neg: 8.4946,
    cuerpo_neu: 57.5208,
  },
  {
    x: language === "es" ? "T2'20" : "Q2'20",
    titular_pos: 8.9308,
    titular_neg: 61.7084,
    titular_neu: 29.36,
    cuerpo_pos: 35.9752,
    cuerpo_neg: 7.1132,
    cuerpo_neu: 56.9112,
  },
  {
    x: language === "es" ? "T3'20" : "Q3'20",
    titular_pos: 12.408,
    titular_neg: 59.162,
    titular_neu: 28.4292,
    cuerpo_pos: 36.5932,
    cuerpo_neg: 6.612,
    cuerpo_neu: 56.7944,
  },
  {
    x: language === "es" ? "T4'20" : "Q4'20",
    titular_pos: 9.916,
    titular_neg: 60.6064,
    titular_neu: 29.4772,
    cuerpo_pos: 36.2472,
    cuerpo_neg: 7.2276,
    cuerpo_neu: 56.5248,
  },
  {
    x: language === "es" ? "T1'21" : "Q1'21",
    titular_pos: 10.1764,
    titular_neg: 63.88,
    titular_neu: 25.944,
    cuerpo_pos: 34.1172,
    cuerpo_neg: 8.4128,
    cuerpo_neu: 57.47,
  },
  {
    x: language === "es" ? "T2'21" : "Q2'21",
    titular_pos: 11.7128,
    titular_neg: 59.6952,
    titular_neu: 28.5912,
    cuerpo_pos: 35.5916,
    cuerpo_neg: 7.0292,
    cuerpo_neu: 57.3796,
  },
  {
    x: language === "es" ? "T3'21" : "Q3'21",
    titular_pos: 9.5176,
    titular_neg: 61.2056,
    titular_neu: 29.2772,
    cuerpo_pos: 33.5484,
    cuerpo_neg: 8.7672,
    cuerpo_neu: 57.6848,
  },
  {
    x: language === "es" ? "T4'21" : "Q4'21",
    titular_pos: 12.1032,
    titular_neg: 58.7624,
    titular_neu: 29.1344,
    cuerpo_pos: 35.6784,
    cuerpo_neg: 7.3212,
    cuerpo_neu: 57.0012,
  },
  {
    x: language === "es" ? "T1'22" : "Q1'22",
    titular_pos: 8.8884,
    titular_neg: 63.2328,
    titular_neu: 27.88,
    cuerpo_pos: 33.936,
    cuerpo_neg: 8.6692,
    cuerpo_neu: 57.3956,
  },
  {
    x: language === "es" ? "T2'22" : "Q2'22",
    titular_pos: 10.5744,
    titular_neg: 61.5488,
    titular_neu: 27.8768,
    cuerpo_pos: 33.4636,
    cuerpo_neg: 7.7576,
    cuerpo_neu: 58.7784,
  },
  {
    x: language === "es" ? "T3'22" : "Q3'22",
    titular_pos: 9.9616,
    titular_neg: 62.2476,
    titular_neu: 27.7912,
    cuerpo_pos: 34.3252,
    cuerpo_neg: 7.9,
    cuerpo_neu: 57.7732,
  },
  {
    x: language === "es" ? "T4'22" : "Q4'22",
    titular_pos: 10.852,
    titular_neg: 62.264,
    titular_neu: 26.8836,
    cuerpo_pos: 33.0644,
    cuerpo_neg: 8.0288,
    cuerpo_neu: 58.9092,
  },
  {
    x: language === "es" ? "T1'23" : "Q1'23",
    titular_pos: 10.522,
    titular_neg: 63.5264,
    titular_neu: 25.952,
    cuerpo_pos: 31.2344,
    cuerpo_neg: 8.4196,
    cuerpo_neu: 60.3448,
  },
  {
    x: language === "es" ? "T2'23" : "Q2'23",
    titular_pos: 8.6976,
    titular_neg: 62.542,
    titular_neu: 28.76,
    cuerpo_pos: 30.634,
    cuerpo_neg: 8.5412,
    cuerpo_neu: 60.8264,
  },
  {
    x: language === "es" ? "T3'23" : "Q3'23",
    titular_pos: 9.5196,
    titular_neg: 63.0284,
    titular_neu: 27.4528,
    cuerpo_pos: 32.3796,
    cuerpo_neg: 7.6572,
    cuerpo_neu: 59.9644,
  },
  {
    x: language === "es" ? "T4'23" : "Q4'23",
    titular_pos: 9.7628,
    titular_neg: 60.658,
    titular_neu: 29.58,
    cuerpo_pos: 34.1168,
    cuerpo_neg: 8.0608,
    cuerpo_neu: 57.8244,
  },
  {
    x: language === "es" ? "T1'24" : "Q1'24",
    titular_pos: 9.9372,
    titular_neg: 60.234,
    titular_neu: 29.8284,
    cuerpo_pos: 33.6092,
    cuerpo_neg: 8.7292,
    cuerpo_neu: 57.6624,
  },
  {
    x: language === "es" ? "T2'24" : "Q2'24",
    titular_pos: 10.4856,
    titular_neg: 58.8008,
    titular_neu: 30.7144,
    cuerpo_pos: 35.3228,
    cuerpo_neg: 8.19,
    cuerpo_neu: 56.4876,
  },
  {
    x: language === "es" ? "T3'24" : "Q3'24",
    titular_pos: 11.1204,
    titular_neg: 57.5056,
    titular_neu: 31.3744,
    cuerpo_pos: 35.7792,
    cuerpo_neg: 7.2336,
    cuerpo_neu: 56.9872,
  },
  {
    x: language === "es" ? "T4'24" : "Q4'24",
    titular_pos: 10.3488,
    titular_neg: 58.5048,
    titular_neu: 31.146,
    cuerpo_pos: 34.4452,
    cuerpo_neg: 6.9428,
    cuerpo_neu: 58.61,
  },
  {
    x: language === "es" ? "T1'25" : "Q1'25",
    titular_pos: 8.5704,
    titular_neg: 62.52,
    titular_neu: 28.9084,
    cuerpo_pos: 28.7316,
    cuerpo_neg: 8.5316,
    cuerpo_neu: 62.7356,
  },
  {
    x: language === "es" ? "T2'25" : "Q2'25",
    titular_pos: 8.6296,
    titular_neg: 61.4844,
    titular_neu: 29.8856,
    cuerpo_pos: 29.05,
    cuerpo_neg: 9.2144,
    cuerpo_neu: 61.7352,
  },
  {
    x: language === "es" ? "T3'25" : "Q3'25",
    titular_pos: 9.0628,
    titular_neg: 62.4316,
    titular_neu: 28.506,
    cuerpo_pos: 29.9072,
    cuerpo_neg: 9.484,
    cuerpo_neu: 60.6084,
  },
  {
    x: language === "es" ? "T4'25" : "Q4'25",
    titular_pos: 9.9416,
    titular_neg: 59.5884,
    titular_neu: 30.4692,
    cuerpo_pos: 32.8664,
    cuerpo_neg: 8.25,
    cuerpo_neu: 58.8852,
  },
  {
    x: language === "es" ? "T1'26" : "Q1'26",
    titular_pos: 11.058,
    titular_neg: 55.9316,
    titular_neu: 33.0112,
    cuerpo_pos: 34.4376,
    cuerpo_neg: 8.152,
    cuerpo_neu: 57.4108,
  },
  {
    x: language === "es" ? "T2'26" : "Q2'26",
    titular_pos: 12.87,
    titular_neg: 58.8776,
    titular_neu: 28.2552,
    cuerpo_pos: 38.3832,
    cuerpo_neg: 7.9852,
    cuerpo_neu: 53.6316,
  },
];

  return (
    progress && (
      <>
        <div
          style={{
            top: "5%",
          }}
          className={`w-full md:w-[60%] font-bold font-md sticky z-50 mt-16 mx-auto rounded-20 right-0 left-0`}
        >
          <div
            className={`overflow-hidden w-full bg-blue rounded-20 md:py-10 md:px-24 p-4 flex-col font-sans text-center font-medium text-white h-full transition-all duration-500 flex text-lg md:text-xl desktop:text-2xl whitespace-pre-line ${
              progress &&
              progress.progress > percChnge &&
              progress.progress <= percChnge2
                ? "opacity-0"
                : "opacity-1"
            }`}
          >
            {progress &&
            progress.progress <= percChnge2 &&
            currentStepIndex <= stepNumber
              ? TEXT["mixed_feelings"]["step3"]["sub_1"][language]
              : TEXT["mixed_feelings"]["step3"]["sub_2"][language]}
          </div>
        </div>

        <div
          style={{
            top: "20%",
            maxWidth: "1022px",
            opacity:
              currentStepIndex < stepNumber - 1
                ? 0
                : currentStepIndex >= stepNumber
                ? 1
                : progress.progress !== 1
                ? progress.progress
                : 0,
          }}
          className={` md:w-[80%] w-[95%] shadow-main font-bold bg-white font-md sticky rounded-20 h-[75vh] mt-[60vh] mx-auto right-0 left-0 flex flex-col`}
        >
          <p
            className={`mt-8 md:pt-16 md:pr-40  font-semibold font-sans text-base md:text-lg text-dark-blue px-4 md:px-0 md:ml-[50px] md:max-w-[60vw] mr-auto transition-all duration-500 opacity-1 `}
          >
            {TEXT["mixed_feelings"]["step3"]["title"][language]}
            <br />
            <span
              className={`font-extrabold transition-all ${
                progress &&
                progress.progress <= percChnge &&
                currentStepIndex <= stepNumber
                  ? "text-base"
                  : "text-[0px]"
              }`}
            >
              {
                TEXT["mixed_feelings"]["step3"]["graph"]["titles"]["Titular"][
                  language
                ]
              }{" "}
            </span>
            <span
              className={`font-extrabold transition-all ${
                progress &&
                progress.progress <= percChnge2 &&
                currentStepIndex <= stepNumber
                  ? "text-[0px]"
                  : "text-base"
              }`}
            >
              {
                TEXT["mixed_feelings"]["step3"]["graph"]["titles"]["Cuerpo"][
                  language
                ]
              }
            </span>
          </p>
          <div className="flex gap-[8px] justify-end w-full px-[80px] relative top-0">
            <div className="bg-green w-[14px] h-[14px] relative top-1 rounded-full"></div>
            <span className="text-grey-chart font-medium text-[14px] text-sans">
              {
                TEXT["mixed_feelings"]["step3"]["graph"]["legends"]["Positivo"][
                  language
                ]
              }
            </span>
            <div className="bg-blue w-[14px] h-[14px] relative top-1 rounded-full"></div>
            <span className="text-grey-chart font-medium text-[14px] text-sans">
              {
                TEXT["mixed_feelings"]["step3"]["graph"]["legends"]["Neutro"][
                  language
                ]
              }
            </span>
            <div className="bg-dark-blue w-[14px] h-[14px] relative top-1 rounded-full"></div>
            <span className="text-grey-chart font-medium text-[14px] text-sans">
              {
                TEXT["mixed_feelings"]["step3"]["graph"]["legends"]["Negativo"][
                  language
                ]
              }
            </span>
          </div>

          <div
            className={`top-[-50px] w-full rounded-20 p-4 md:p-10 flex-col font-sans text-lg md:text-xl text-center font-medium text-white h-full transition-all relative ${
              currentStepIndex < stepNumber ? "hidden" : "flex"
            } overflow-hidden `}
            ref={barGraph}
          >
            <div className="absolute h-full w-full">
              <BarChart
                data={data}
                barKey={
                  progress &&
                  progress.progress <= percChnge2 &&
                  currentStepIndex <= stepNumber
                    ? "titular"
                    : "cuerpo"
                }
                height={height}
                barGraph={barGraph}
              />
            </div>
          </div>
        </div>
      </>
    )
  );
}
